<template lang="pug">
  #app
    v-app
      .snack-wrap
        v-snackbar(v-model='snackbar' :multi-line='snackbarDescription != null' :timeout='4500' top="top")
          .snackbar-content
            .snackbar-text
              | {{ snackbarText }}
            .snackbar-description
              | {{ snackbarDescription }}
      transition(name="fade-transition" mode="out-in")
          router-view
</template>

<script>
import { EventBus } from "./_tools/eventbus.js";

export default {
  name: "App",

  data() {
    return {
      snackbar: false,
      snackbarText: null,
      snackbarDescription: null,
    };
  },
  mounted() {
    console.log(this.$vuetify.theme.isDark);
    if (localStorage.getItem("isDark") === "true") {
      this.$vuetify.theme.isDark = true;
    } else {
      this.$vuetify.theme.isDark = false;
    }

    EventBus.$on("themeEvent", () => {
      this.$vuetify.theme.isDark = !this.$vuetify.theme.isDark;

      if (this.$vuetify.theme.isDark) {
        localStorage.setItem("isDark", "true");
        document.querySelector("body").style.backgroundColor = "#121212";
      } else {
        localStorage.setItem("isDark", "false");
        document.querySelector("body").style.backgroundColor =
          "rgb(245, 245, 249)";
      }
    });

    // Light theme #ff3e1d
    this.$vuetify.theme.themes.light.primary = "#8592A3";
    this.$vuetify.theme.themes.light.success = "#71dd37";
    this.$vuetify.theme.themes.light.danger = "#ff3e1d";
    // Dark theme
    this.$vuetify.theme.themes.dark.primary = "#8592A3";
    EventBus.$on("snackbarEvent", (data) => {
      this.snackbarText = typeof data === "string" ? data : data.message;
      this.snackbarDescription = typeof data === "string" ? undefined : data.description;
      this.snackbar = true;
    });
  },

  beforeDestroy: function () {
    EventBus.$off("snackbarEvent");
    EventBus.$off("themeEvent");
  },
};
</script>
<style scoped lang="sass">
.snackbar-content
  display: flex
  flex-direction: column
  gap: 4px
  .snackbar-text
    font-size: 14px
    font-weight: 500
  .snackbar-description
    font-size: 12px
    font-weight: 400

</style>
